/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {useIsMobileWeb} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {BodyText, Heading} from '#/wsocial/components/primitives'
import {IllustrationScanSuccessful} from './illustrations'
import {
  BackButton,
  Divider,
  IllustrationArea,
  PageShell,
  SupportFooter,
  TwoLinksFooter,
} from './primitives'

export function StepScanSuccessful({
  onBack,
  onSkip,
  onNext,
}: {
  onBack: () => void
  onSkip?: () => void
  onNext: () => void
}) {
  const isMobileWeb = useIsMobileWeb()

  return (
    <PageShell>
      <IllustrationArea>
        <IllustrationScanSuccessful />
      </IllustrationArea>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <Heading>
          {!isMobileWeb && 'Scan successful'}
          {isMobileWeb && 'Finish set up'}
        </Heading>
        <BodyText>
          Follow the steps in the W Identity app to verify your identity.
        </BodyText>
      </div>

      {isMobileWeb ? (
        <>
          <div
            style={{
              padding: '16px 16px',
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}>
            <Button
              label="Continue"
              color="primary"
              size="large"
              onPress={onNext}
              style={{width: '100%'}}>
              <ButtonText>Continue</ButtonText>
            </Button>
            {onSkip && (
              <Button
                label="Remind me later"
                color="secondary"
                size="large"
                onPress={onSkip}
                style={{width: '100%'}}>
                <ButtonText>Remind me later</ButtonText>
              </Button>
            )}
            <Button
              label="Go back"
              color="secondary"
              size="large"
              onPress={onBack}
              style={{width: '100%'}}>
              <ButtonText>Back</ButtonText>
            </Button>
          </div>
          <SupportFooter />
        </>
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              padding: '16px 16px',
            }}>
            <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
              <BackButton onPress={onBack} />
              {onSkip && (
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}>
                  <Button
                    label="Remind me later"
                    color="secondary"
                    size="large"
                    onPress={onSkip}>
                    <ButtonText>Remind me later</ButtonText>
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              padding: '0 16px 16px',
            }}>
            <Divider />
            <TwoLinksFooter onClick={onNext} />
          </div>
        </>
      )}
    </PageShell>
  )
}
